import axios, { AxiosResponse } from 'axios';

import AddTestTypeInput from 'modules/Global/models/AddTestTypeInput';

export default function createAsync(apiUrl: string) {
  return function api<TResponse>(
    input: AddTestTypeInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/test-type-definitions`,
          method: 'POST',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
